import React from 'react'

import { Box, Skeleton as CSkeleton } from '@mui/material'

const Skeleton: React.FC = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="16px"
      padding="16px"
      height="90vh"
    >
      <Box
        width="calc(100% - 60px)"
        marginTop="-45px"
        marginBottom="10px"
        display="flex"
        justifyContent="space-between"
      >
        <CSkeleton width="150px" height="35px" variant="rounded" />
        <CSkeleton width="100px" height="22px" variant="rounded" />
      </Box>
      <CSkeleton width="100%" height="150px" variant="rounded" />
      <CSkeleton width="100%" height="150px" variant="rounded" />
      <CSkeleton width="100%" height="150px" variant="rounded" />
      <CSkeleton width="100%" height="150px" variant="rounded" />
      <CSkeleton width="100%" height="150px" variant="rounded" />
    </Box>
  )
}

export default Skeleton
